import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const supportedLngs = ['sl', 'en', 'de', 'it', 'hr', 'es', 'ru'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'sl',
    fallbackLng: 'sl',
    supportedLngs,
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      cookieMinutes: 365 * 24 * 60,
    },
  });

export { supportedLngs };
export default i18n;